import { render, staticRenderFns } from "./Actores.vue?vue&type=template&id=da2b9a22&"
import script from "./Actores.vue?vue&type=script&lang=js&"
export * from "./Actores.vue?vue&type=script&lang=js&"
import style0 from "./Actores.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports